export default __webpack_public_path__ + "static/media/s_circled.5902ecef.svg";